import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

class Dropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedOption: props.selected,
      isShowOption: false,
    };

    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    this.insertNotSelect();
    document.addEventListener("click", this.handleClickOutside, true);
  }

  componentDidUpdate(prevProps) {
    const { list, selected } = this.props;
    const { selectedOption } = this.state;
    if (prevProps.list !== list && list) {
      this.insertNotSelect();
    }
    if (selected !== selectedOption) {
      this.setState({ selectedOption: selected });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside, true);
  }

  insertNotSelect = () => {
    const { list, other, t } = this.props;
    if (
      other &&
      list &&
      list.length > 0 &&
      list.filter((item) => item.value === "").length === 0
    ) {
      list.unshift({ text: t("TCMS01012_selectPlaceholder"), value: "" });
    }
  };

  handleClickOutside = (event) => {
    const { shouldHide } = this.props;
    if (
      shouldHide &&
      this.wrapperRef &&
      !this.wrapperRef.current.contains(event.target)
    ) {
      this.setState({ isShowOption: false });
    }
  };

  click = () => {
    const { isShowOption } = this.state;
    this.setState({ isShowOption: !isShowOption });
  };

  select = (item) => {
    const { onChange } = this.props;
    this.setState({
      selectedOption: item,
      isShowOption: item.value === "5" && item.text === "その他の期間",
    });
    onChange && onChange(item);
  };

  render() {
    const { list, placeholder, children, disabled } = this.props;
    const { isShowOption, selectedOption } = this.state;

    return (
      <div
        ref={this.wrapperRef}
        className="custom-select-input"
        disabled={disabled}
      >
        <div role="button" onClick={this.click} className="custom-select-btn" tabIndex={disabled ? "-1" : "0"}>
          {(selectedOption && selectedOption.text) ||
            (list.length > 0 ? placeholder : "-")}
        </div>
        {isShowOption && (
          <div className="options">
            {(list || []).map((item) => (
              <div
                className={`option ${
                  selectedOption && selectedOption.value === item.value
                    ? "active"
                    : ""
                }`}
                onClick={() => this.select(item)}
                key={item.value}
                tabIndex="0"
              >
                {item.text}
              </div>
            ))}
            {children}
          </div>
        )}
      </div>
    );
  }
}

Dropdown.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  selected: PropTypes.shape({
    text: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }),
  other: PropTypes.bool,
  shouldHide: PropTypes.bool,
};

Dropdown.defaultProps = {
  placeholder: "",
  disabled: false,
  other: true,
  shouldHide: true,
};

export default withTranslation()(Dropdown);
